/**
 * Shared Tailwind class for a tappable drawer row (icon + label).
 * Used by DrawerMenuItem, NestedDrawerMenuItem, and other drawer rows
 * so the row styling stays consistent across the mobile shell drawers.
 */
export const DRAWER_ITEM_BUTTON_CLASS =
  "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left hover:bg-hover";
